const invalidSymbolsRegexp = /[*%&?!=/:<>{}[\]()'"`;]/;

const EMPTY_VALUE_ERROR =
  'Please enter your search request into the Search field';
const INVALID_VALUE_ERROR =
  'Please do not use script symbols (* % & ? ! = / :) in your query';

export const validateSearchValue = (value: string): string | null => {
  if (!value) {
    return EMPTY_VALUE_ERROR;
  }

  if (invalidSymbolsRegexp.test(value)) {
    return INVALID_VALUE_ERROR;
  }

  return null;
};

export const validateCheckboxSearchValue = (value: string): string | null => {
  if (invalidSymbolsRegexp.test(value)) {
    return INVALID_VALUE_ERROR;
  }

  return null;
};
